/* eslint-disable no-constant-condition */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BsExclamationTriangleFill } from "react-icons/bs";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ApiPaths } from "../../../api/paths";
import GridDetailItem from "../../../components/grid-detail-item/GridDetailItem";
import DropdownIcon from "../../../components/icons/DropdownIcon";
import useData from "../../../hooks/use-data";
import { GridItemType } from "../../../types/common";
import { CoverType } from "../../../types/cover";
import { getStringDate } from "../../../utils/utc-date-conversion";
import NautilusAsset from "../../purchase-cover/nautilus-asset-page/NautilusAsset";
import useDisclosure from "../../../hooks/use-disclosure";

export default function AssetCoverDetails() {
  const { coverId } = useParams();
  const {
    onHide: onHideNautilusAsset,
    onShow: onShowNautilusAsset,
    show: showNautilusAsset,
  } = useDisclosure();
  const { t } = useTranslation(["common", "myCovers"]);
  const [selectedOption, setSelectedOption] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { data } = useData<CoverType>(`${ApiPaths.covers}/${coverId}`, {
    onError: (err) => {
      toast(err.response?.data?.message || "An error occurred", {
        type: "error",
      });
    },
  });

  const cover_details_map: GridItemType[] = [
    {
      accessor: "product",
      label: t("details.label.cover.cover", { ns: "myCovers" }),
      value: (val) => val?.product_name,
    },
    {
      accessor: "product",
      label: t("details.label.cover.id", { ns: "myCovers" }),
      value: (val) => val?.product_name,
    },
    {
      accessor: "product",
      label: t("details.label.cover.product_name", { ns: "myCovers" }),
      value: (val) => val?.product_name,
    },
    {
      accessor: "product",
      label: t("details.label.cover.product_type", { ns: "myCovers" }),
      value: (val) => val?.product_name,
    },
    {
      accessor: "period",
      label: t("details.label.cover.period", { ns: "myCovers" }),
      value: (val) => `${val} days`,
    },
    {
      accessor: "cover_amount",
      label: t("details.label.cover.amount", { ns: "myCovers" }),
      value: (val) => (
        <p>
          {new Intl.NumberFormat("en-us", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 0,
          }).format(val)}
        </p>
      ),
    },
    {
      accessor: "cover_start_date",
      label: t("details.label.cover.start_date", { ns: "myCovers" }),
      value: (val) => getStringDate(val),
    },
    {
      accessor: "cover_premium_amount",
      label: t("details.label.cover.premium", { ns: "myCovers" }),
      value: (val) => (
        <p>
          {new Intl.NumberFormat("en-us", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 0,
          }).format(val)}
        </p>
      ),
    },
    {
      accessor: "cover_end_date",
      label: t("details.label.cover.end_date", { ns: "myCovers" }),
      value: (val) => getStringDate(val),
    },
  ];

  const handleSubmitSelectionAssetCovers = () => {
    if (selectedOption === "cancel") {
      setRedirectURL(
        "https://app.clustdoc.com/cp/10546640-gyC789fsDZl5c7tbTVIA9xAPpNJMYW"
      );
      onShowNautilusAsset();
      return;
    }
    if (selectedOption === "raise") {
      setRedirectURL(
        "https://app.clustdoc.com/cp/10546554-wUJxkbjTL9AsHdbbopTHmcVVUaeIcF"
      );
      onShowNautilusAsset();
      return;
    }
    if (selectedOption === "extend") {
      setRedirectURL(
        "https://app.clustdoc.com/cp/10546638-pP04nOh7iLdcTuskNaQDPTTjgu1Qit"
      );
      onShowNautilusAsset();
      return;
    }
    toast("Please select an action first", {
      type: "error",
      toastId: "cover-option",
    });
  };

  return (
    <div className="p-3 pb-5 mb-5">
      <NautilusAsset
        onHide={onHideNautilusAsset}
        show={showNautilusAsset}
        redirectURL={redirectURL}
      />
      <div className="d-md-flex align-items-center justify-content-between mb-3">
        <h2 className="primary-title font-14 mb-3 mb-md-0 ">
          {t("details.heading.cover", { ns: "myCovers" })}
        </h2>
        <div className="d-flex justify-content-between justify-content-md-end align-items-center">
          <div className="position-relative me-md-4">
            <div className="drop-down-icon">
              <DropdownIcon />
            </div>
            <select
              name=""
              id=""
              className="covers-drop-down border-0"
              onChange={(e) => setSelectedOption(e.target.value)}
              disabled={false}
            >
              <option value="">
                {t("details.placeholder.action", { ns: "myCovers" })}
              </option>
              <option value="cancel">
                {t("details.options.cancel", { ns: "myCovers" })}
              </option>
              <option value="extend">
                {t("details.options.extend", { ns: "myCovers" })}
              </option>
              <option value="raise">
                {t("details.options.raise", { ns: "myCovers" })}
              </option>
            </select>
          </div>
          <button
            className="primary-button text-decoration-none buy-covers-button"
            style={{ whiteSpace: "nowrap" }}
            onClick={handleSubmitSelectionAssetCovers}
          >
            {t("button.submit", { ns: "common" })}
          </button>
        </div>
      </div>
      {true ? (
        <>
          <div className="box-shadow px-3 py-3 px-md-5 py-md-4 bg-white rounded-2 mb-3">
            <div className="claim-details-status d-flex justify-content-between  pb-3 mb-3 ">
              <h2 className="primary-title font-14 ">
                {t("details.heading.cover", { ns: "myCovers" })}
              </h2>
              {data && (
                <div>
                  <p className="d-none d-md-inline secondary-color font-14 me-1">
                    {t("details.label.cover.status", { ns: "myCovers" })}:
                  </p>
                  <span
                    className={`status-button ${data?.cover_status.toLowerCase()}-status py-2 px-3 fw-bold`}
                  >
                    {data?.cover_status}
                  </span>
                </div>
              )}
            </div>
            <div className="client-details client-details-cont d-grid">
              {cover_details_map.map((item) => {
                const val = item.accessor;
                return (
                  <GridDetailItem
                    key={item.accessor}
                    label={item.label}
                    data={item.value(data && data[val as keyof CoverType])}
                  />
                );
              })}
            </div>
          </div>
        </>
      ) : (
        <div className="box-shadow px-3 py-3 px-md-5 py-md-4 bg-white rounded-2 mb-5 text-center">
          <BsExclamationTriangleFill className="mb-2 details-error-icon" />
          <h2 className="font-16">
            {t("details.error.fetch_details", { ns: "myCovers" })}
          </h2>
        </div>
      )}
    </div>
  );
}
